import React, { PureComponent } from "react";
import _ from "lodash";
import { WithTitle } from ".";
import { withRedux } from "../hoc";
import icon1 from "../assets/images/step-to-get-quote/1.png";
import icon2 from "../assets/images/step-to-get-quote/2.png";
import icon3 from "../assets/images/step-to-get-quote/3.png";
import icon4 from "../assets/images/step-to-get-quote/4.png";

const steps = [
  {
    number: "1",
    title: "Find",
    icon: icon1,
    detail: {
      en: 'Search by <span class="text-red">CODE</span> or use FILTER or upload photo.',
      th: "ค้นหาด้วยรหัสสินค้า หรือใช้ฟิลเตอร์ หรืออัพโหลดรูป"
    }
  },
  {
    number: "2",
    title: "Decide",
    icon: icon2,
    detail: {
      en:
        'Click <i class="fa fa-heart text-red" aria-hidden="true"></i>, add the product to be <span class="text-red">QUOTED</span>.',
      th: "คลิกที่รูปหัวใจเพื่อเพิ่มสินค้าที่ต้องการขอใบเสนอราคา"
    }
  },
  {
    number: "3",
    title: "Complete The Form",
    icon: icon3,
    detail: {
      en: '<span class="text-red">GIVE US</span> your contact info and specific requirements.',
      th: "ใส่ข้อมูลของคุณให้ครบถ้วนและความต้องการของคุณ"
    }
  },
  {
    number: "4",
    title: "Wait For Us",
    icon: icon4,
    detail: {
      en: 'We will <span class="text-red">CONTACT</span> you back ASAP.',
      th: "เราจะติดต่อกลับคุณโดยเร็วที่สุด"
    }
  }
];

const mapStateToProps = state => {
  return {
    t: _.get(state, "t"),
    languages: _.get(state, "languages")
  };
};

const actions = {};

@withRedux(mapStateToProps, actions)
export default class StepsToGetQuote extends PureComponent {
  render() {
    const { t } = this.props;
    return (
      <div className="steps-to-get-quote">
        <div className="container">
          <WithTitle title={t("4 STEPS to get QUOTE")} backgroundColor="#131c4e">
            <div className="row">
              {_.map(steps, (step, key) => {
                const { number, title, icon, detail } = step;
                return (
                  <div key={key} className="col-md-3">
                    <div className="step-block">
                      <div className="left">
                        <div className="step-number">{number}</div>
                      </div>
                      <div className="right">
                        <div className="title">
                          <div className="text">{t(title)}</div>
                          <div className="icon">
                            <img src={icon} alt={t(detail)} />
                          </div>
                        </div>
                        <div className="detail">
                          <span dangerouslySetInnerHTML={{ __html: t(detail) }} />
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </WithTitle>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/StepsToGetQuote.js